<div class="d-flex flex-column">
  @if (isException()) {
    <span class="bold text-uppercase text-muted">{{ 'pages.transport.detail-page.events.exception' | translate }}</span>
  }

  @if (harmonizedEvent()) {
    <div class="fs-5 bold">{{ harmonizedEvent() }}</div>
  }

  @if (location()) {
    <div class="text-muted">{{ location() }}</div>
  }

  @if (technicalInfo()) {
    <div>
      <span class="text-muted" CopyOnHover>{{ technicalInfo() }}</span>
    </div>
  }

  @if (eventData().timestamp) {
    <div class="mt-1">
      <span>
        @if (eventData().timezone) {
          {{ eventData().timestamp | dayjs: 'L LT' }} ({{ eventData().timezone }})
        } @else {
          {{ eventData().timestamp | dayjs: 'L LT' : true }}
        }
      </span>
    </div>
  }
</div>
